import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useEffect, useState } from "react";
import { LazyAppDownloadNudge } from "./LazyAppDownloadNudge";
import { useCanShowAppDownloadNudge } from "./useCanShowAppDownloadNudge";
var DELAY_MS = 4000;
export var AppDownloadNudgeWrapper = function() {
    var canShowNudge = useCanShowAppDownloadNudge();
    var _useState = _sliced_to_array(useState(true), 2), isDelayingRender = _useState[0], setIsDelayingRender = _useState[1];
    useEffect(function() {
        var timer = setTimeout(function() {
            setIsDelayingRender(false);
        }, DELAY_MS);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    if (!canShowNudge || isDelayingRender) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(LazyAppDownloadNudge, {})
    });
};
